export enum ResidentChangeLogCategory {
  Unknown = 'Unknown',
  Device = 'Device',
  Information = 'Information',
  Scenario = 'Scenario',
  MuteScenarios = 'MuteScenarios',
}
